import { Modal } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { Button } from "../../../components";
import { FormSelect } from "../../../components/forms";
import useExportContactDetails, { CommunicationPreferenceFilters, ContactExportOptions, EmailExportOptions } from "../hooks/useExportContactDetails";
import { ServiceAgreementsSelect } from "../../../components/forms/selects";
import ThemedModal from "../../../components/utilities/ThemedModal";

const ExportContactDetailsModal = ({ isEmailExport, onHide, ...modalProps }) => {

    const {
        control,
        setValue,
        onCancel,
        onSubmit
    } = useExportContactDetails({ isEmailExport, onHide });

    return <Modal size="lg" centered onHide={onCancel} {...modalProps}>
        <ThemedModal.Header closeButton>
            <Modal.Title>Export {isEmailExport ? "Client Emails" : "Contact Details"}</Modal.Title>
        </ThemedModal.Header>
        <form onSubmit={onSubmit}>
            <Modal.Body>
                <div className="row gy-2">
                    <p className="mt-1 pb-0 mb-0">Select Service Level Agreement(s) clients in the export should have.</p>
                    <div className="col-12">
                        <Controller
                            control={control}
                            name="serviceLevelAgreementIds"
                            render={({ field: { onChange, value, ...rest } }) => (
                                <ServiceAgreementsSelect
                                    {...rest}
                                    label="Service Level Agreement(s)"
                                    defaultValue={value}
                                    onChange={(selection) => setValue('serviceLevelAgreementIds', selection.map((selection) => selection.value))}
                                    includeNoneOption
                                    isMulti
                                    isClearable
                                    disableAnimations
                                />
                            )}
                        />
                    </div>
                    <p className="mt-4 pb-0 mb-0">Select the communication preferences clients in the export must have enabled.</p>
                    <div className="col-12">
                        <Controller
                            control={control}
                            name="filters"
                            render={({ field: { onChange, value, ...rest } }) => (
                                <FormSelect
                                    {...rest}
                                    label="Required Preferences"
                                    defaultValue={value}
                                    onChange={(selection) => setValue('filters', selection.map((selection) => selection.value))}
                                    options={CommunicationPreferenceFilters}
                                    isMulti
                                    isClearable
                                    disableAnimations
                                />
                            )}
                        />
                    </div>
                    {isEmailExport
                        ? <>
                            <p className="mt-4 pb-0 mb-0">
                                Select the email types you want to export.
                            </p>
                            <div className="col-12">
                                <Controller
                                    control={control}
                                    name="emails"
                                    render={({ field: { onChange, value, ...rest } }) => (
                                        <FormSelect
                                            {...rest}
                                            label="Email Types"
                                            defaultValue={value}
                                            onChange={(selection) => setValue('emails', selection.map((selection) => selection.value))}
                                            options={EmailExportOptions}
                                            isMulti
                                            isClearable
                                            disableAnimations
                                        />
                                    )}
                                />
                            </div>
                        </>
                        : <>
                            <p className="mt-4 pb-0 mb-0">
                                Select the contact details you want to export.
                            </p>
                            <div className="col-12">
                                <Controller
                                    control={control}
                                    name="contactDetails"
                                    render={({ field: { onChange, value, ...rest } }) => (
                                        <FormSelect
                                            {...rest}
                                            label="Contact Details"
                                            defaultValue={value}
                                            onChange={(selection) => setValue('contactDetails', selection.map((selection) => selection.value))}
                                            options={ContactExportOptions}
                                            isMulti
                                            isClearable
                                            disableAnimations
                                        />
                                    )}
                                />
                            </div>
                        </>}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" type="submit">Export</Button>
                <Button variant="light" onClick={onCancel}>Cancel</Button>
            </Modal.Footer>
        </form>
    </Modal>
}

export default ExportContactDetailsModal;